export default "__VITE_ASSET__bc0ff61d__"